export default {
  // Page metadata
  'meta.title': '利用規約 - timer.today',
  'meta.description': 'timer.todayオンラインタイミングツールプラットフォームの利用規約と使用契約。サービスルール、ユーザーの権利と責任について学びます。',

  // Page header
  'page.title': '利用規約',
  'page.lastUpdated': '最終更新日：{{date}}',
  'page.intro': 'timer.todayへようこそ。これらの利用規約は、timer.today（timer.today）のウェブサイトの使用に関するルールと規制を概説しています。',

  // Section 1
  'section1.title': '1. 規約の承認',
  'section1.content': 'このウェブサイトにアクセスして使用することにより、この契約の条項と規定に拘束されることに同意します。上記に同意しない場合は、このサービスを使用しないでください。',

  // Section 2
  'section2.title': '2. サービスの説明',
  'section2.intro': 'timer.todayは以下の無料オンラインタイミングツールを提供します：',
  'section2.timer': 'カウントダウンタイマー - 生産性、料理、時間管理のためのカスタマイズ可能なタイマー',
  'section2.stopwatch': 'ストップウォッチ - スポーツ、トレーニング、精密タイミングのための高精度タイミングツール',
  'section2.worldclock': '世界時計 - グローバルタイムゾーンのリアルタイム表示',

  // Section 3
  'section3.title': '3. 使用ライセンス',
  'section3.intro': 'timer.todayを個人的、非商用の一時的な閲覧のために一時的に使用する許可が付与されます。これはライセンスの付与であり、所有権の移転ではなく、このライセンスの下では以下を行うことはできません：',
  'section3.item1': '素材を変更またはコピーすること',
  'section3.item2': '商用目的または公開表示のために素材を使用すること',
  'section3.item3': 'ウェブサイトに含まれるソフトウェアのリバースエンジニアリングを試みること',
  'section3.item4': '素材から著作権またはその他の所有権表示を削除すること',

  // Section 4
  'section4.title': '4. プライバシーとデータ',
  'section4.intro': 'timer.todayはあなたのプライバシーを保護することに尽力しています：',
  'section4.item1': '個人情報を収集または保存しません',
  'section4.item2': 'タイマー設定はブラウザにローカルに保存されます',
  'section4.item3': 'ユーザーの行動や使用パターンを追跡しません',
  'section4.item4': '追跡目的でクッキーは使用されません',

  // Section 5
  'section5.title': '5. 免責事項',
  'section5.content': 'timer.todayの素材は「現状のまま」提供されます。timer.todayは明示的または黙示的な保証を行わず、特定の目的への適合性、商品性、知的財産権の非侵害またはその他の権利侵害を含む、すべての他の保証または条件を否認し、無効にします。',

  // Section 6
  'section6.title': '6. 制限',
  'section6.content': 'いかなる場合も、timer.todayまたはそのサプライヤーは、timer.todayの素材の使用または使用不能から生じる損害（データまたは利益の損失による損害、または事業中断による損害を含むがこれらに限定されない）について責任を負わないものとします。たとえtimer.todayまたはその承認された代表者がそのような損害の可能性について口頭または書面で通知されていた場合でも同様です。',

  // Section 7
  'section7.title': '7. 素材の正確性',
  'section7.content': 'timer.todayに表示される素材には、技術的、印刷上、または写真の誤りが含まれる場合があります。timer.todayは、そのウェブサイトの素材が正確、完全、または最新であることを保証しません。timer.todayは、予告なしにいつでもウェブサイトに含まれる素材を変更することがあります。',

  // Section 8
  'section8.title': '8. 変更',
  'section8.content': 'timer.todayは、予告なしにいつでもそのウェブサイトの利用規約を改訂することがあります。このウェブサイトを使用することにより、あなたは現在のバージョンの利用規約に拘束されることに同意します。',

  // Section 9
  'section9.title': '9. お問い合わせ先',
  'section9.intro': 'これらの利用規約について質問がある場合は、お問い合わせください：',
  'section9.email': 'メール：',
  'section9.emailSubject': '利用規約に関するお問い合わせ - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. All rights reserved.'
};
